// Confirmed team origin cities. Coordinates are approximate city centers (longitude, latitude).
export const teamLocations = [
  { id: 'anqing', longitude: 117.05, latitude: 30.53 },
  { id: 'hefei', longitude: 117.23, latitude: 31.82 },
  { id: 'nantong', longitude: 120.89, latitude: 31.98 },
  { id: 'suzhou', longitude: 120.59, latitude: 31.3 },
  { id: 'hangzhou', longitude: 120.16, latitude: 30.27 },
  { id: 'beijing', longitude: 116.4, latitude: 39.9 },
  { id: 'shanghai', longitude: 121.47, latitude: 31.23 },
];
